import includes from 'lodash/includes';

class LocalizeService {
  constructor() {
    this.supportedLanguages = ['en', 'es', 'pt-BR'];
    this.countriesLanguage = {
      argentina: 'es',
      brazil: 'pt-BR',
      mexico: 'es',
      paraguay: 'es',
      peru: 'es',
      uruguay: 'es',
      bolivia: 'es',
      chile: 'es',
      'costa rica': 'es',
      'dominican republic': 'es',
      ecuador: 'es',
      'el salvador': 'es',
      guatemala: 'es',
      honduras: 'es',
      nicaragua: 'es',
      panama: 'es',
      venezuela: 'es'
    };
  }

  exists() {
    return !!window.Localize;
  }

  checkIfSupported(lang) {
    return includes(this.supportedLanguages, lang);
  }

  getLanguage() {
    return this.exists() && this.checkIfSupported(window.Localize.getLanguage()) && window.Localize.getLanguage() || 'en';
  }

  setLanguage(lang) {
    this.exists() && window.Localize.setLanguage(lang);
    if (window.drift && window.drift.config) {
      window.drift.config({
        locale: lang
      });
    }
  }

  translate(input) {
    return this.exists() && window.Localize.translate(input) || input;
  }

  getLanguageForCountry(country) {
    return this.countriesLanguage[country] || 'en';
  }
}

export default new LocalizeService();